/**
 * Copyright(c) 2019 Knut Petter Meen, all rights reserved.
 */
package net.scalytica.blaargh.utils

import japgolly.scalajs.react.extra.router.BaseUrl

// scalastyle:off magic.number
object StaticConfig {

  val baseUrl: BaseUrl = BaseUrl.until_# //until(PathPrefix)

  val rootUrl: String = baseUrl.value.dropRight(10)

  def urlFromRoot(uriString: String): String = {
    if (rootUrl.startsWith("file://")) {
      // Page is read from local file system
      s"$rootUrl/$uriString"
    } else {
      // Page is hosted on a server
      baseUrl.value + uriString
    }
  }

}



// WEBPACK FOOTER //
// /Users/kpm/Development/scalytica/renslebraten.no/_project/src/main/scala/net/scalytica/blaargh/utils/StaticConfig.scala